module.exports = __webpack_public_path__ + "static/img/basic04.1efda68d.png";